import React, { Fragment } from "react";

const NewMembers = () => {
  return (
    <Fragment>
      <div className="online-users-profile">
        <div className="online-title-container-alt">
          <div className="border-alt green">
            <p className="online-title-alt green">Welcome to ime!</p>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/innovator.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/mentor.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/employer.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/innovator.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/mentor.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/employer.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/innovator.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/mentor.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="user-online-item">User Job Title</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={
                    "https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/employer.png"
                  }
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NewMembers;
